<template>
  <v-container fluid pa-0 class="activity-details">
    <portal to="context-portal">
      <activity-header :activity="activity"/>
    </portal>
    <v-layout row class="content-area-layout">
      <v-flex xs6 fill-height style="overflow-y: auto;" v-if="!mapOnly">
        <tile>
          <activity-segments
            :segments="activity && activity.segment_efforts ? activity.segment_efforts : []"
            @item-hover="(a) => hoveredSegment = a"
          />
        </tile>
      </v-flex>
      <v-flex fill-height pa-1 :class="mapOnly ? 'xs12' : 'xs6'">
        <tile>
          <!-- <map-view :polyline="polyline" :bounds="bounds"/> -->
          <l-map-view ref="map" :polyline="polyline" :bounds="bounds" :show-attribution="false"/>
        </tile>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dataAccessor from '@/data-access/dataAccessor';
import MapView from '@/ux/generic-components/MapView.vue';
import LMapView from '@/ux/generic-components/LMapView.vue';
import ActivitySegments from '@/ux/components/activities/ActivitySegments.vue';
import ActivityHeader from '@/ux/components/headers/ActivityHeader.vue';
import Tile from '@/ux/generic-components/Tile.vue';
import loadingMixin from '@/mixins/loadingMixin';
import sizeAwareMixin from '@/mixins/sizeAwareMixin';
import PolylineDecoder from '@/library/PolylineDecoder';
import geometry from '@/library/Geometry';
import activity from '@/routes/activity';
// import eventBus from '@/events/eventBus';

export default {
  name: 'activity-detail-view',
  components: { LMapView, MapView, Tile, ActivitySegments, ActivityHeader },
  props: {
    id: {
      type: [Number, String],
      required: true,
      default: null,
    },
  },
  mixins: [loadingMixin, sizeAwareMixin],
  data: () => ({
    activity: {},
    polyline: null,
    hoveredSegment: null,
    mapOnly: false,
  }),
  computed: {
    bounds() {
      let bnds = null;
      if (this.hoveredSegment) {
        bnds = geometry.bounds([geometry.toLatLng(this.hoveredSegment.segment.start_latlng),
        geometry.toLatLng(this.hoveredSegment.segment.end_latlng)]);
      }
      return bnds;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async onResize(args) {
      this.mapOnly = (args.height < 600) || (['sm', 'xs'].includes(args.name));
    },
    async load() {
      this.loadingStart(`Loading activity`);
      const d = new PolylineDecoder();
      this.activity = await dataAccessor.getActivity(this.id);
      this.stream = await dataAccessor.getActivityStreams(this.id);
      this.centre = { lat: this.activity.start_latlng[0], lng: this.activity.start_latlng[1] };
      this.polyline = this.activity && this.activity.map ? this.activity.map.polyline : [];
      this.loadingEnd();
      this.attachMapButtons();
    },
    attachMapButtons() {
      this.$refs.map.addButton('image', `Activity elevation profile`, () => {
        this.$router.push({ name: 'activityProfile', params: { id: this.id } });
      });
      if (this.activity.photos.count > 0) {
        this.$refs.map.addButton('photo_camera', `${this.activity.photos.count} x photo(s)`, () => {
          this.$router.push({ name: 'activityPhotos', params: { id: this.id } });
        });
      }
      if (this.activity.segment_efforts.length > 0) {
        this.$refs.map.addButton('timeline', `${this.activity.segment_efforts.length} x segment(s)`, () => {
          this.$router.push({ name: 'activitySegmentEfforts', params: { id: this.id } });
        });
      }
    },
  },
};
</script>


<style lang="scss">
.activity-details {
  .segment-bottom-screen {
    overflow-y: auto;
    height: 30%;
  }
  .segment-full-screen {
    overflow-y: auto;
    height: 100%;
  }
}
</style>